import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../../styles/Page.css';
import FeaturedPost from '../../components/FeaturedPost';

function MainPage() {
  const [featuredPosts, setFeaturedPosts] = useState([]);

  useEffect(() => {
    const fetchFeaturedPosts = async () => {
      try {
        const response = await fetch('/api/blog/posts/featured');
        if (response.ok) {
          const data = await response.json();
          setFeaturedPosts(data);
        }
      } catch (error) {
        console.error('Failed to fetch featured posts:', error);
      }
    };

    fetchFeaturedPosts();
  }, []);

  return (
    <>
      <title>WizeHelper - AI-Powered Reddit Analytics</title>
      <meta name="description" content="AI-powered Reddit analysis tools for lead generation, market research, and business intelligence. Discover opportunities and optimize your Reddit strategy." />
      <div className="MainPage">
        <div className="page-container bg-background-light">
          <section className="text-center my-24">
            <h1
              className="text-6xl md:text-7xl font-black text-text-light-primary dark:text-text-dark-primary mb-6 leading-tight tracking-tighter">
              Level Up Your <span className="text-[#1F7A8C] dark:text-[#BFDBF7]">Reddit</span> Game
            </h1>
            <p className="text-xl !text-[#1F7A8C] dark:!text-[#BFDBF7] max-w-4xl mx-auto font-sans leading-7">
              Dive into a suite of powerful tools built to skyrocket your Reddit presence. Find leads, craft viral
              posts, and understand your audience like never before. Ready to dominate?
            </p>
          </section>
          <div className="mx-auto px-6" style={{ maxWidth: '88rem' }}>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-4 gap-8">
              <Link to="/pain-extractor"
                className="bg-container-light dark:bg-card-dark p-8 rounded-lg shadow-lg hover:shadow-2xl hover:-translate-y-2 transition-all duration-300 cursor-pointer no-underline hover:no-underline"
                style={{ textDecoration: 'none !important' }}>
                <div
                  className="bg-[#1F7A8C]/10 dark:bg-[#1F7A8C]/20 text-[#1F7A8C] dark:text-[#BFDBF7] w-16 h-16 rounded-full flex items-center justify-center mb-6">
                  <span className="material-icons-outlined text-3xl">edit</span>
                </div>
                <h4 className="text-xl font-bold mb-2 text-[#022B3A] dark:text-[#FFFFFF] select-none">Pain Extractor</h4>
                <p className="text-[#1F7A8C] dark:text-[#BFDBF7] select-none">Extract customer pain points from Reddit
                  discussions.</p>
              </Link>
              <Link to="/post-enhancer"
                className="bg-container-light dark:bg-card-dark p-8 rounded-lg shadow-lg hover:shadow-2xl hover:-translate-y-2 transition-all duration-300 cursor-pointer no-underline hover:no-underline"
                style={{ textDecoration: 'none !important' }}>
                <div
                  className="bg-[#1F7A8C]/10 dark:bg-[#1F7A8C]/20 text-[#1F7A8C] dark:text-[#BFDBF7] w-16 h-16 rounded-full flex items-center justify-center mb-6">
                  <span className="material-icons-outlined text-3xl">auto_awesome</span>
                </div>
                <h4 className="text-xl font-bold mb-2 text-[#022B3A] dark:text-[#FFFFFF] select-none">Post Enhancer</h4>
                <p className="text-[#1F7A8C] dark:text-[#BFDBF7] select-none">Enhance your Reddit posts with AI-powered suggestions.</p>
              </Link>
              <Link to="/post-timer"
                className="bg-container-light dark:bg-card-dark p-8 rounded-lg shadow-lg hover:shadow-2xl hover:-translate-y-2 transition-all duration-300 cursor-pointer no-underline hover:no-underline"
                style={{ textDecoration: 'none !important' }}>
                <div
                  className="bg-[#1F7A8C]/10 dark:bg-[#1F7A8C]/20 text-[#1F7A8C] dark:text-[#BFDBF7] w-16 h-16 rounded-full flex items-center justify-center mb-6">
                  <span className="material-icons-outlined text-3xl">timer</span>
                </div>
                <h4 className="text-xl font-bold mb-2 text-[#022B3A] dark:text-[#FFFFFF] select-none">Post Timer</h4>
                <p className="text-[#1F7A8C] dark:text-[#BFDBF7] select-none">Find the best time to post on Reddit.</p>
              </Link>
              <div
                className="bg-container-light dark:bg-card-dark p-8 rounded-lg shadow-lg hover:shadow-2xl hover:-translate-y-2 transition-all duration-300 no-underline">
                <div
                  className="bg-[#1F7A8C]/10 dark:bg-[#1F7A8C]/20 text-[#1F7A8C] dark:text-[#BFDBF7] w-16 h-16 rounded-full flex items-center justify-center mb-6">
                  <span className="material-icons-outlined text-3xl">add</span>
                </div>
                <h4 className="text-xl font-bold mb-2 text-[#022B3A] dark:text-[#FFFFFF] select-none">More Tools Coming</h4>
                <p className="text-[#1F7A8C] !text-[#1F7A8C] dark:text-[#BFDBF7] dark:!text-[#BFDBF7] select-none">We're always building new features to level
                  up your game.</p>
              </div>
            </div>

            {featuredPosts.length > 0 && (
              <div className="mt-24 mb-12">
                <h2 className="text-4xl font-bold text-center mb-12 text-[#022B3A] dark:text-[#FFFFFF]">
                  Latest Tips & <span className="text-[#1F7A8C] dark:text-[#BFDBF7]">Insights</span>
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                  {featuredPosts.map(post => (
                    <FeaturedPost key={post.slug} post={post} />
                  ))}
                </div>
                <div className="text-center mt-12">
                  <Link to="/blog" className="inline-block px-8 py-3 bg-[#1F7A8C] text-white font-bold rounded-lg hover:bg-[#165C6B] transition-colors">
                    View All Tips
                  </Link>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default MainPage;